import { Document, Identifiable } from "@planzone/dto";

type Folder = {
  type: "folder";
  name: string;
  description: string;
  createdDate: string;
  createdBy: string;
  lastModified: string;
  editedBy: string;
  planzoneUuid: string;
  projectUuid: string;
  children: (Identifiable<Folder> | Identifiable<Document>)[];
};

const folder: Folder = {
  type: "folder",
  name: "",
  description: "",
  createdDate: "",
  createdBy: "",
  lastModified: "",
  editedBy: "",
  planzoneUuid: "",
  projectUuid: "",
  children: [],
};

export type { Folder };

export { folder };
